import * as __WEBPACK_EXTERNAL_MODULE_json_stringify_safe_eb014bbd__ from "json-stringify-safe";
import * as __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__ from "./mask.mjs";
const MAX_DATA_LENGTH = 204800;
const FIELD_IS_EMPTY = 'FIELD_IS_EMPTY';
const DEFAULT_REDACTED_STORE_KEYS = [
    'trl',
    'areaTree',
    'profareaTree',
    'industriesTree',
    'professionalRoleTree',
    'contactPhones',
    'xsrfToken',
    'languages',
    "vacancyFull.description"
];
const createStateTransformer = ({ stateTransformer, redactedFields, maxDataLength })=>(state)=>{
        const originalTrl = state?.trl;
        let transformedState = stateTransformer ? stateTransformer(state) : state;
        if (!transformedState) return null;
        transformedState = (0, __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__.maskMany)(transformedState, __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__.genericLengthStubber, [
            ...DEFAULT_REDACTED_STORE_KEYS,
            ...redactedFields?.store ?? []
        ]);
        const stateLength = (0, __WEBPACK_EXTERNAL_MODULE_json_stringify_safe_eb014bbd__["default"])(transformedState).length;
        const maxStateLength = maxDataLength ?? MAX_DATA_LENGTH;
        if (stateLength > maxStateLength) return {
            trlsLength: originalTrl ? (0, __WEBPACK_EXTERNAL_MODULE_json_stringify_safe_eb014bbd__["default"])(originalTrl).length : 0,
            basicState: {
                request: transformedState?.request ?? FIELD_IS_EMPTY,
                locale: transformedState?.locale ?? FIELD_IS_EMPTY,
                langs: transformedState?.langs ?? FIELD_IS_EMPTY
            },
            __removed: `State is out of limit and has been stripped (${stateLength}/${maxStateLength})`
        };
        return transformedState;
    };
export { createStateTransformer };

//# sourceMappingURL=stateTransformer.mjs.map